/**
 * Configuration file for Intercom
 */

module.exports = {

  /**
   * ID reflecting the application environment to load
   *
   * Intercom includes two ids; one for the production environment
   * and a second for the staging/test environment.
   */

  appId: 'aw5b6i5l',

  /**
   * Unique identifier for the company
   *
   * Should be consistent across all environments
   */

  companyId: 'cbuoy',

  /**
   * Common name for the company
   *
   * This should be different for each environment
   */

  companyName: 'C-Buoy'

};



// WEBPACK FOOTER //
// ./config/intercom.js